import { COUNTRY_SHORT_NAME } from '@commons/constants';
import { getEnvironment } from './index';
import getBaseUrl from './getBaseUrl';
import {
  LOCAL_ENVIRONMENT,
  TEST_ENVIRONMENT,
  DOCKER_ENVIRONMENT,
} from './constants';

export const providersKeys = {
  plexo: 'MASTERCARD',
  edenred: 'EDENRED',
  visanet: 'VISA',
  oca: 'OCA',
  creditel: 'CREDITEL',
};

const environment = getEnvironment();

const BASE_URL =
  environment === LOCAL_ENVIRONMENT ||
  environment === TEST_ENVIRONMENT ||
  environment === DOCKER_ENVIRONMENT
    ? 'https://localhost:8443'
    : getBaseUrl(COUNTRY_SHORT_NAME.URUGUAY);

const externalPaymentProviderConfig = {
  [providersKeys.edenred]: {
    getUrl: ({
      userHash,
      country = COUNTRY_SHORT_NAME.URUGUAY,
      cardType = 615,
    }) =>
      `${BASE_URL}/checkout/loadedenred?u=${cardType}_${userHash}&c=.${country}&pwa=true`,
  },
  [providersKeys.visanet]: {
    getUrl: ({ userHash, country = COUNTRY_SHORT_NAME.URUGUAY }) =>
      `${BASE_URL}/checkout/loadvisa_net?u=${userHash}&c=.${country}&pwa=true`,
  },
  [providersKeys.oca]: {
    getUrl: ({ userHash, country = COUNTRY_SHORT_NAME.URUGUAY }) =>
      `${BASE_URL}/checkout/loadoca?u=${userHash}&c=.${country}&pwa=true`,
  },
  [providersKeys.plexo]: {
    getUrl: ({
      userHash,
      country = COUNTRY_SHORT_NAME.URUGUAY,
      cardType = 'mastercard',
    }) =>
      `${BASE_URL}/checkout/v2/loadplexo?u=${cardType}_${userHash}&c=.${country}&pwa=true`,
  },
  [providersKeys.creditel]: {
    getUrl: ({ userHash, country = COUNTRY_SHORT_NAME.URUGUAY }) =>
      `${BASE_URL}/checkout/v2/loadplexo?u=creditel_${userHash}&c=.${country}&pwa=true`,
  },
};

export default function getConfig(providerKey) {
  const config = externalPaymentProviderConfig[providerKey];
  if (!providerKey || !config) return null;
  return config;
}
